<template>
  <div>
    <div class="contanierDiv">
		<img src="../assets/images/ali/ali_title.png" class="titleImg" mode='aspectFit' />
		<van-form @submit="handleSearchMerc" style="width: 100%;">
			<div class="formDiv">
				<div class="form-title">
					<img src="../assets/images/ali/no_icon.png" class="noIcon"/>
					<div class="title-text">商户号</div>
				</div>
				<div class="inputDiv">
					<van-field
						input-align="left"
						error-message-align="left"
						size="large"
						v-model="merId"
						maxlength="15"
						placeholder="请输入商户号"
						:rules="[{ required: true, message: '请输入商户号' }]"
					/>
				</div>
			</div>
			<div class="search-btn">
				<van-button round block color="linear-gradient(to right, #FFCE05, #FBC002)" native-type="submit">
					查询
				</van-button>
			</div>
		</van-form>
	</div>
  </div>
</template>

<script>
import { Toast } from 'vant'

export default {
  data () {
    return {
		docHeight: '',
		merId: '',
    }
  },
  mounted () {
	  let param = this.$route.query
	  this.merId = param.merId
	  if(this.merId){
		  this.handleSearchMerc()
	  }
    this.$nextTick(() => {
      let docHeight = document.documentElement.clientHeight
      console.log('可视区域高度', docHeight)
      this.docHeight = docHeight + 'px'
      // 获取屏幕高度，为元素添加高度
      // 不使用 100vh 的原因：安卓手机上，键盘抬起会算作屏幕元素，100vh会发生变化，键盘收起时，100vh会比初始值小
    })
  },
  methods: {
	handleSearchMerc(){
		let params = {
			merId: this.merId
		}
		this.getRequest('/api/cold-butler-compose/aliAuthH5/qryMerAliAuthSts', params).then(res => {
		  console.log('返回数据1',res)
		  if (res && res.data.code === 200) {
			let backData = res.data.data
			if(backData.alipaySts === '1'){
				this.dialog1()
			}else if(backData.alipaySts === '2'){
				this.dialog2()
			}else if(backData.alipaySts === '3'){
				this.dialog3()
			}else if(backData.alipaySts === '4'){
				if(backData.checkResult === '1'){
					this.dialog6()
				}else if(backData.checkResult === '2'){
					//跳转成功页面
					this.$router.push({
					  path: '/aliReportAuthSuccess',
					  query: backData
					})
				}else if(backData.checkResult === '3'){
					this.dialog7(backData.failMsg)
				}
			}else if(backData.alipaySts === '5'){
				this.dialog5(backData)
			}
		  }else{
			  this.$toast(res.data.msg, { type: 'fail' })
		  }
		})
	},
	//未上报
	dialog1(){
		this.$dialog.alert({
		  title: '未上报',
		  message: '支付宝商户每日9：00-20：00自动报备，请在该时段内查询报备结果，谢谢！',
		  confirmButtonText: '确认'
		}).then(() => {
		  // on close
		});
	},
	//上报中
	dialog2(){
		this.$dialog.alert({
		  title: '上报中',
		  message: '正在报备，请稍后查询，谢谢！',
		  confirmButtonText: '确认'
		}).then(() => {
		  // on close
		});
	},
	//审核中
	dialog3(){
		this.$dialog.alert({
		  title: '审核中',
		  message: '正在审核，请等待！',
		  confirmButtonText: '确认'
		}).then(() => {
		  // on close
		});
	},
	//审核失败
	dialog5(data){
		this.$dialog.confirm({
			title: '失败',
			message: `原因：${data.failMsg}`,
			confirmButtonText: '重新上传资料',
			cancelButtonText: '取消'
		}).then(() => {
			// on confirm
			//跳转上传图片页面
			this.$router.push({
			  path: '/aliReportMakeUpPic',
			  query: {merId: data.merId}
			})
		})
		.catch(() => {
			// on cancel
		});
	},
	//认证中
	dialog6(){
		this.$dialog.alert({
		  title: '认证中',
		  message: '正在审核，请等待！',
		  confirmButtonText: '确认'
		}).then(() => {
		  // on close
		});
	},
	//认证失败
	dialog7(failMsg){
		this.$dialog.alert({
		  title: '认证失败',
		  message: `原因：${failMsg}`,
		  confirmButtonText: '确认'
		}).then(() => {
		  // on close
		});
	}
  }
}
</script>
<style>
	.contanierDiv {
		display: flex;
		flex-direction: column;
		align-items: center;
		background-image: url("../assets/images/ali/ali_bg.png");
		background-size: 100% 100%;
		width: 100%;
		overflow: auto;
		position: relative;
	}
	.titleImg {
		width: 304px;
		height: 64px;
		/* margin-top: 70px; */
		position: absolute;
		top: 70px;
	}
	.formDiv{
		background-color: #ffffff;
		width: 94%;
		margin-left: 3%;
		height: auto;
		margin-top: 350px;
		border-radius: 10px;
		padding: 31px 20px;
		box-sizing: border-box;
	}
	.form-title{
		display: flex;
		align-items: center;
	}
	.noIcon{
		width: 38px;
		height: 30px;
		margin-right: 10px;
	}
	.title-text{
		color: #333333;;
		font-size: 20px;
		font-weight: 500;
	}
	.inputDiv{
		margin: 25px 0 8px 0;
		.van-cell{
			padding: 0 0 0 5px !important;
			font-size: 20px !important;
		}
	}
	/* .van-cell{
		padding: 0 0 0 5px !important;
		font-size: 20px !important;
	} */
	.search-btn {
		height: 170px;
		width: 94%;
		margin-left: 3%;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.van-button__content span{
		/* color: #693106; */
	}
</style>
